var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAnalysis56 = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 56,
  height: 56,
  viewBox: "0 0 56 56",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.5 10C6.22386 10 6 10.2239 6 10.5C6 10.7761 6.22386 11 6.5 11H36.5C36.7761 11 37 10.7761 37 10.5C37 10.2239 36.7761 10 36.5 10H6.5ZM6.5 22C6.22386 22 6 22.2239 6 22.5C6 22.7761 6.22386 23 6.5 23H20.5C20.7761 23 21 22.7761 21 22.5C21 22.2239 20.7761 22 20.5 22H6.5ZM6.5 34C6.22386 34 6 34.2239 6 34.5C6 34.7761 6.22386 35 6.5 35H20.5C20.7761 35 21 34.7761 21 34.5C21 34.2239 20.7761 34 20.5 34H6.5ZM6 46.5C6 46.2239 6.22386 46 6.5 46H36.5C36.7761 46 37 46.2239 37 46.5C37 46.7761 36.7761 47 36.5 47H6.5C6.22386 47 6 46.7761 6 46.5Z",
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M29 28.5C29 24.3579 32.3579 21 36.5 21C40.6421 21 44 24.3579 44 28.5C44 30.5608 43.1688 32.4275 41.8234 33.7831C41.8164 33.7894 41.8095 33.7959 41.8027 33.8027C41.7959 33.8095 41.7894 33.8164 41.7831 33.8234C40.4275 35.1688 38.5608 36 36.5 36C32.3579 36 29 32.6421 29 28.5ZM42.1465 34.8536C40.6451 36.1889 38.6673 37 36.5 37C31.8056 37 28 33.1944 28 28.5C28 23.8056 31.8056 20 36.5 20C41.1944 20 45 23.8056 45 28.5C45 30.6673 44.1889 32.6451 42.8536 34.1465L49.8538 41.1467C50.0491 41.342 50.0491 41.6585 49.8538 41.8538C49.6585 42.0491 49.342 42.0491 49.1467 41.8538L42.1465 34.8536Z",
  fill: "var(--icon-decorative-coral)"
})));
export default SvgAnalysis56;